import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { GenericModal } from 'src/v2/components/generic-modal'
import { CircleIcon } from 'src/components/icons/circle-icon'
import styled from '@emotion/styled'
import { ParcelMap } from 'src/v2/views/owner-reveal/insights/parcels/parcel-modal/parcel-map'
import { BuildingAndLotCard } from 'src/v2/views/owner-reveal/insights/parcels/parcel-modal/building-and-lot-card'
import { ZoningCard } from 'src/v2/views/owner-reveal/insights/parcels/parcel-modal/zoning-card'
import { FinancesCard } from 'src/v2/views/owner-reveal/insights/parcels/parcel-modal/finances-card'
import { AssociatedOwnersCard } from 'src/v2/views/owner-reveal/insights/parcels/parcel-modal/associated-owners'
import { MapSquareIcon } from 'src/components/icons/map-square'
import * as atoms from 'src/v2/state/owner-reveal/entity-parcels'
import { useAtomValueLoadable } from 'src/utils/jotai'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const Row = styled.div`
  display: flex;
  gap: 16px;
`

type ParcelModalProps = {
  open: boolean
  onClose: () => void
}

export const ParcelModal: FC<ParcelModalProps> = ({ open, onClose }) => {
  const parcelLoadable = useAtomValueLoadable(atoms.selectedParcel)
  const parcel = parcelLoadable.state === 'hasData' ? parcelLoadable.data : undefined

  return (
    <GenericModal
      width={700}
      height={700}
      open={open}
      onClose={onClose}
      title={parcel?.address ?? '--'}
      subtitle={`APN# ${parcel?.apn}`}
      headerLoading={parcelLoadable.state === 'loading'}
      icon={
        <CircleIcon size={40} color={Colors.primaryGreen700}>
          <MapSquareIcon size={16} />
        </CircleIcon>
      }>
      <Content>
        <ParcelMap />
        <Row>
          <BuildingAndLotCard />
          <ZoningCard />
        </Row>
        <FinancesCard />
        <AssociatedOwnersCard />
      </Content>
    </GenericModal>
  )
}
